export default __webpack_public_path__ + "static/media/member1.d4455da6.jpg";